var map = {
	"./batch/index.tsx": 228,
	"./businessPartner/index.tsx": 980,
	"./item/index.tsx": 95,
	"./location/index.tsx": 150,
	"./serial/index.tsx": 229,
	"./warehouse/index.tsx": 356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1611;